import { useEffect, useRef } from 'react';
import { useRecoilValue } from 'recoil';
import { useToast } from '@/hooks/V3/useToast';
import { useLog } from '@/hooks/V3/useLog';
import { useAppSelector } from '@/redux/store';
import { deviceUuidState } from '@/store/atom';
import type { DiagnosisListItem } from '@/types/productOptimization';

/**
 * list 응답 변경 시 직전 스냅샷과 비교하여 Analyzing → Completed 로 전환된
 * 항목이 1개 이상이면 success toast 를 띄우고 완료 이벤트를 로깅한다.
 */
export const useCompletedToast = (diagnoses: DiagnosisListItem[]) => {
  const { showToast } = useToast();
  const userNo = useAppSelector((s) => s.user.UserNo);
  const deviceUuid = useRecoilValue(deviceUuidState);
  const { setUserEventHistory } = useLog(userNo);
  const prevStatusMap = useRef<Map<number, string>>(new Map());

  useEffect(() => {
    const becameCompleted = diagnoses.filter(
      (d) => d.status === 'Completed' && prevStatusMap.current.get(d.id) === 'Analyzing',
    );

    if (becameCompleted.length > 0) {
      showToast('success', '상품 최적화 진단이 완료되었어요. 결과를 확인해보세요.');
      becameCompleted.forEach((d) => {
        setUserEventHistory({
          eventName: 'optimization_diagnosis_complete_web',
          eventValue: String(d.id),
          deviceUuid,
        });
      });
    }

    const next = new Map<number, string>();
    diagnoses.forEach((d) => next.set(d.id, d.status));
    prevStatusMap.current = next;
  }, [diagnoses, showToast, setUserEventHistory, deviceUuid]);
};
